<template>
	<b-row lg="12" class="mt-2">

		<!-- Has the client had any hospital stays since your last visit? -->
		<b-col :lg="cols ? cols : 6">
			<b-form-group label="Has the client had any hospital stays since your last visit?" label-class="h5">
				<b-form-radio-group v-model="hospitalStayData.hospital_stay" id="hospitalStay" name="hospitalStay" required>
					<b-form-radio value="1">Yes</b-form-radio>
					<b-form-radio value="0">No</b-form-radio>
				</b-form-radio-group>
			</b-form-group>
		</b-col>

		<!-- Is the client still currently in the hospital? -->
		<b-col :lg="cols ? cols : 6"
			v-if="hospitalStayData.hospital_stays_enhanced_flow && hospitalStayData.hospital_stay == 1">
			<b-form-group label="Is the client still currently in the hospital?" label-class="h5">
				<b-form-radio-group v-model="hospitalStayData.still_in_hospital" id="stillInHospital"
					name="stillInHospital"
					:required="(hospitalStayData.hospital_stays_enhanced_flow == 1) ? true : false">
					<b-form-radio value="1">Yes</b-form-radio>
					<b-form-radio value="0">No</b-form-radio>
				</b-form-radio-group>
			</b-form-group>
		</b-col>

		<!-- Hospital Stay - From and To Date -->
		<b-col :lg="cols ? cols : 6"
			v-if="hospitalStayData.hospital_stays_enhanced_flow && hospitalStayData.hospital_stay == 1">
			<b-form-group label="Hospital Stay Dates" label-for="from_date">
				<div class="from-to-dates-grid">

					<!-- From label for small devices -->
					<div class="pb-1">
						&nbsp;from&nbsp;
					</div>

					<!-- From date selector with error / info message -->
					<div>
						<date-picker v-model="hospitalStayData.from_date" placeholder="Date (MM/DD/YYYY)"
							:required="hospitalStayData.hospital_stays_enhanced_flow && hospitalStayData.hospital_stay == 1"></date-picker>

						<div>
							<small class="form-text pl-2">
								<div class="icon-message" :class="fromIsValid ? 'text-success' : 'text-danger'">
									<i class="fa" :class="fromIsValid ? 'fa-check-circle' : 'fa-info-circle'"></i>
									<span class="pl-2">
										{{fromMessage}}
									</span>
								</div>
							</small>
						</div>
					</div>

					<!-- To label for small devices -->
					<div class="py-1">
						&nbsp;to&nbsp;
					</div>

					<!-- To Date selector with error / info message -->
					<div>
						<date-picker v-model="hospitalStayData.to_date" placeholder="Date (MM/DD/YYYY)"
							:required="hospitalStayData.hospital_stays_enhanced_flow && hospitalStayData.still_in_hospital == 0"
							:disabled="hospitalStayData.still_in_hospital == 1"></date-picker>
						<div>
							<small v-if="hospitalStayData.still_in_hospital == 0" class="form-text pl-2">

								<div class="icon-message" :class="toIsValid ? 'text-success' : 'text-danger'">
									<i class="fa" :class="toIsValid ? 'fa-check-circle' : 'fa-info-circle'"></i>
									<span class="pl-2">
										{{toMessage}}
									</span>
								</div>
							</small>
							<small v-if="hospitalStayData.still_in_hospital == 1" class="form-text text-info pl-2">
								<i class="fa fa-info-circle"></i> &nbsp; Not Applicable.
							</small>
						</div>
					</div>
				</div>
			</b-form-group>
		</b-col>
	</b-row>
</template>

<script>

import FormatsDates from "../mixins/FormatsDates";
import { mapState } from 'vuex';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex'

export default {

	mixins: [FormatsDates],
	props: {
		cols: {
			type: Number,
			required: false
		},
	},
	data() {
		return {
			fromMeta: {},
			toMeta: {},
			
		}
	},
	computed: {
		...mapState({
			count: state => state.hospital.count,
			shifts: state => state.hospital.shifts,
			hospitalStayData: state => state.hospital.hospitalStay,
		}),
		...mapGetters('hospital',[
      		'stayIsValid', // add the names of the getters you want to import
			'fromConditionOne',
			'fromConditionTwo',
			'toConditionOne',
			'toConditionTwo',
			'fromIsValid',
			'toIsValid',
	]),
	max() {
		return this.hospitalStayData.max;
	},
	today() {
		return new Date().toLocaleDateString('en-US');
	},
	hasShift() {
		return (this.shifts) ? true : false;
	},
	fromIsValid() {
      return this.fromConditionOne && this.fromConditionTwo;
   	},
	fromConditionTwo() {
		const fromDate = new Date(this.hospitalStayData.from_date);
		const toDate = new Date(this.hospitalStayData.to_date);

		if (isNaN(fromDate.getTime()) || isNaN(toDate.getTime())) {
			return false;
		}

		return fromDate <= toDate;
	},
	fromMessage() {

		if(this.hospitalStayData.from_date){
			let messages = '', messageOne = '', messageTwo = '';

			if (!this.fromConditionOne) {
				messageOne = 'The Hospital Stay From Date cannot be after the shift check out date. ';
			}

			if (!this.fromConditionTwo) {
				messageTwo = 'The Hospital Stay From Date cannot be after the Hospital Stay to Date. ';
			}

			return  messages = messageOne + messageTwo;
		}else{
			return 'From Date is required';
		}
	},
	toMessage() {
		if(this.hospitalStayData.to_date){
		let messages = '', messageOne = '', messageTwo = '';
		
		(this.toConditionOne == false) ? messageOne = 'The Hospital Stay End Date cannot be after the shift check out date . ' : null;
		(this.toConditionTwo == false) ? messageTwo = 'The Hospital Stay End Date cannot be before the Hospital Stay From Date. ' : null;
	
		return messages = messageOne + messageTwo;
		}else{
			return 'To Date is required when the client is not currently in the hospital.';
		}
	},
	},
	methods: {

		...mapActions('hospital', [
			'getShifts',
			'setHospitalStayVariable',
		]),
	}
}
</script>

<style>
.from-to-dates-grid {
	display: grid;
	grid-template-columns: 1fr auto 1fr;
}

.from-to-dates-grid>div:nth-child(1) {
	display: none;
}

.icon-message {
	display: flex;
	align-items: center;
}

@media only screen and (max-width: 475px) {
	.from-to-dates-grid {
		grid-template-columns: 1fr;
	}

	.from-to-dates-grid>div:nth-child(1),
	.from-to-dates-grid>div:nth-child(3) {
		display: block;
		text-transform: capitalize;
	}
}
</style>
